var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"switchlang"}},[_c('p',{on:{"click":function($event){return _vm.setlocate()}}},[_vm._v(_vm._s(_vm.langs.toUpperCase()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }